let ConversationFeedback = {
  get: async function(startIndex, limit, params) {
    try {
      const authToken = await localStorage.getItem("token");
      let url = `${process.env.REACT_APP_API_BASE_URL}/logs/conversation-feedback?offset=${startIndex}&limit=${limit}`;
      if (params) {
        params = new URLSearchParams(params).toString().replace("%2C", ",");
        if (params.length > 0) {
          url = url + `&${params}`;
        }
      }
      const request = new Request(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      });
      const response = await fetch(request);

      if (response.status === 401) {
        await localStorage.removeItem("token");
        throw new Error('Unauthorized');
      }

      const json = await response.json();
      return json;
    } catch (exception) {
      console.log(exception);
      throw exception;
    }
  },
  load: async function(uuid) {
    try {
      const authToken = await localStorage.getItem("token");
      const url = `${process.env.REACT_APP_API_BASE_URL}/logs/conversation-feedback/${uuid}`;
      const request = new Request(url, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      });
      const response = await fetch(request);

      if (response.status === 401) {
        await localStorage.removeItem("token");
        throw new Error('Unauthorized');
      }

      const json = await response.json();
      return json;
    } catch (exception) {
      console.log(exception);
      throw exception;
    }
  }
};

export default ConversationFeedback;
